<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"  :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td><a target="_blank" @click="openPayDetail(item.ID)">{{ item.RequestCode }}</a></td>
                            <td>{{ item.Username}}</td>
                            <td>{{ item.ReceiverPhone}}</td>
                            <td>{{ item.ReceiverAddress}}</td>
                            <td class="text-end">{{ item.TotalPackage | currency('', 0)}}</td>
                            <td>{{ item.ShippingMethod | display_value(shipping_methods) }}</td>
                            <td class="truncate">
                                <v-tooltip top max-width="250" color="light-blue lighten-2 black--text">
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ item.CustomerNote }}</span>
                                    </template>
                                    <span>{{ item.CustomerNote }}</span>
                                </v-tooltip>
                            </td>
                            <td v-if="(adminRole || paymentRole || csRole) && item.Status < 3">
                                <v-edit-dialog :return-value.sync="item.Status" large lazy persistent @save="saveItem({ID: item.ID, Status: item.Status})">
                                    <div v-bind:style="{'color': get_status_color(item.Status, request_status)} ">{{ item.Status | display_value(request_status) }}</div>
                                    <template v-slot:input>
                                        <v-select :items="request_status" v-model="item.Status" item-text="name" item-value="value" ></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td v-bind:style="{'color': get_status_color(item.Status, request_status)} " v-else>
                                {{ item.Status | display_value(request_status) }}
                            </td>
                            <td>{{ item.CreatedDate | display_date }}</td>
                            <td>{{ item.CreatedBy }}</td>
                            <td>{{ item.ModifiedBy }}</td>
                            <td class="text-center">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="saveItem({ID: item.ID, Status: 3}, 0)">
                                        <v-icon :disabled="item.Status != 2" color="blue darken-2" class="mr-2">fa-file-export</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Xuất kho</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="printInList(item.ID)">
                                        <v-icon color="red darken-2" class="mr-2">fa-print</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>In phiếu</span>
                                </v-tooltip>
                                <a target="_blank" @click="openPayDetail(item.ID)"><i role="button" medium="" class="v-icon notranslate mr-2 v-icon--link material-icons theme--light">{{item.Status == 1 ? 'edit' : 'visibility'}}</i></a>
                                <v-icon :disable="item.Status || !(adminRole || paymentRole)" :color="item.Status ? '#d0d0c0' : 'gray'" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="dialogPayDetail" max-width="700px">
        <v-card>
            <v-card-title>
            <span class="title">Chi tiết yêu cầu giao hàng #{{currentPaymentRequest.ID || 'Tạo mới'}}</span>
            </v-card-title>
            <v-card-text>
            <v-container grid-list-md pa-0>
                <v-layout row wrap>
                    <v-flex lg12>
                        <v-autocomplete label="Khách hàng" v-model="currentPaymentRequest.UID" :items="customers" :item-text="getCustomerText" item-value="ID" @change="onSelectedCustomer" :readonly="currentPaymentRequest.ID > 0"></v-autocomplete>
                    </v-flex>
                    <v-flex lg12 v-if="!currentPaymentRequest.ID">
                        <v-autocomplete label="Địa chỉ" v-model="selectedAddressID" :items="addressBooks" :item-text="getAddressText" item-value="ID" @change="onSelectedAddress" :readonly="currentPaymentRequest.Status > 1"></v-autocomplete>
                    </v-flex>
                    <v-flex lg6 md6 sm12>
                        <v-text-field v-model="currentPaymentRequest.ReceiverName" label="Người nhận" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg6 md6 sm12>
                        <v-text-field v-model="currentPaymentRequest.ReceiverPhone" label="Điện thoại" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12 md12 sm12>
                        <v-text-field v-model="currentPaymentRequest.ReceiverAddress" label="Địa chỉ" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg6 md6 sm12>
                        <v-textarea rows="2" v-model="currentPaymentRequest.CustomerNote" label="Ghi chú KH" class="input-group--focused"></v-textarea>
                    </v-flex>
                    <v-flex lg6 md6 sm12>
                        <v-textarea rows="2" v-model="currentPaymentRequest.Note" label="Ghi chú DL" class="input-group--focused"></v-textarea>
                    </v-flex>
                    <v-flex lg12 class="font-weight-bold" v-if="currentPaymentRequest.ID > 0">
                        <div>Số đơn yêu cầu: {{currentPaymentRequest.TotalOrder | currency}}</div>
                    </v-flex>
                    <v-flex lg12 class="font-weight-bold" v-if="!currentPaymentRequest.ID && (adminRole || paymentRole)">
                        <v-checkbox label="Cho xuất kho nợ" v-model="isPayLaster"></v-checkbox>
                    </v-flex>
                    <v-flex lg12 v-if="currentPaymentRequest.ID > 0">
                        <v-data-table
                        :headers="orderHeader"
                        :items="currentPaymentRequest.Orders"
                        :mobile-breakpoint="100"
                        :items-per-page="100"
                        :server-items-length="currentPaymentRequest.Orders ? currentPaymentRequest.Orders.length : 0"
                        :hide-default-footer="true"
                        item-key="ID"
                        >
                        <template v-slot:item="{ item }">
                            <tr>
                            <td>{{ item.TransactionCode }}</td>
                            <td>
                                <a target="_blank" :href="(item.OrderType == 1 ? '/don-hang/chi-tiet/' : '/ky-gui/') + item.OrderID">{{(item.OrderType == 1 ? 'MD' : 'KG') + item.OrderID}}</a>
                            </td>
                            <td class="text-end">{{ item.NumberOfPack | currency}}</td>
                            <td class="text-end">{{ item.Weight | currency('', 2)}}</td>
                            <td class="text-end">{{ item.Volume | currency('', 2)}}</td>
                            <td class="text-end">{{ item.WeightByVolume | currency('', 1)}}</td>
                            <td class="text-end">{{ (item.FeeShipType != 1 ? (item.FeeShipType == 0 ? item.Weight : item.WeightByVolume) : 0) | currency('', 1) }}</td>
                            <td class="text-end">{{ (item.FeeShipType == 1 ? item.Volume : 0) | currency('', 2) }}</td>
                            <td>{{ item.OrderNote}}</td>
                            </tr>
                        </template>
                        <template v-slot:body.append>
                            <tr>
                            <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{totalPackageNumber | currency}}</td>
                            <td class="text-end font-weight-bold">{{totalWeight | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{totalVolume | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{totalWeightByVolume | currency('', 1)}}</td>
                            <td class="text-end font-weight-bold">{{totalPayWeight | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{totalPayVolume | currency('', 1)}}</td>
                            <td class="text-end font-weight-bold"></td>
                            </tr>
                        </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex lg12 v-else>
                        <v-data-table
                        :headers="newOrderHeader"
                        :items="newOrders"
                        :mobile-breakpoint="100"
                        :items-per-page="100"
                        :server-items-length="newOrders ? newOrders.length : 0"
                        :hide-default-footer="true"
                        item-key="PKey"
                        show-select v-model="selectedOrders"
                        >
                        <template v-slot:item="{ item, isSelected, select }">
                            <tr :active="isSelected" @click="select(!isSelected)">
                            <td>
                                <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                            </td>
                            <td>
                                <a target="_blank" :href="(item.OrderType == 1 ? '/don-hang/chi-tiet/' : '/ky-gui/') + item.ID">{{(item.OrderType == 1 ? 'MD' : 'KG') + item.ID}}</a>
                            </td>
                            <td class="text-end">{{ item.Weight | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{ item.TotalAmountVND | currency}}</td>
                            <td class="text-end">{{ item.Deposit | currency}}</td>
                            <td class="text-end">{{ item.RemainAmount | currency}}</td>
                            </tr>
                        </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red white--text" @click="dialogPayDetail = false">Đóng</v-btn>
            <v-btn v-if="currentPaymentRequest.Status == 1" color="blue white--text" @click="updateAddress">Cập nhật</v-btn>
            <v-btn v-if="!currentPaymentRequest.ID" color="blue white--text" @click="saveNewRequest">Lưu lại</v-btn>
            <v-btn absolute top right class="mt-1" @click="printPayOrder">
                <v-icon color="red" class="mr-2">print</v-icon>In đơn
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Vue from 'vue';
import { sendErrorNotice } from "@/commons/utils";
import { request_list, print_export_receipt_order_v1 } from '@/commons/hpod';
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            orderHeader: [
                {
                    text: "Mã vận đơn",
                    right: false
                },
                {
                    text: "Mã đơn hàng",
                    right: false
                },
                {
                    text: "Số kiện",
                    align: "end"
                },
                {
                    text: "Cân nặng",
                    align: "end"
                },
                {
                    text: "Kích thước",
                    align: "end"
                },
                {
                    text: "Cân quy đổi",
                    align: "end"
                },
                {
                    text: "Cân tính tiền",
                    align: "end"
                },
                {
                    text: "Khối tính tiền",
                    align: "end"
                },
                {
                    text: "Ghi chú"
                }
            ],
            pagination: {...configs.PAGINATION, sortBy: ["ID"]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "paymentRequest_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            request_status: configs.PAYMENT_REQUEST_STATUS,
            shipping_methods: configs.SHIPPINGMETHODS,
            dialogPayDetail: false,
            selectedAddressID: 0,
            newOrders: [],
            selectedOrders: [],
            newOrderHeader: [
                {
                    text: "Đơn hàng",
                    value: "ID",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng cân",
                    value: "Weight",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng tiền",
                    value: "TotalAmountVND",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Đã trả",
                    value: "Deposit",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Còn thiếu",
                    value: "RemainAmount",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
            ],
            isPayLaster: false
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        loading() {
            if(!this.loading && this.$route.query.id && this.$route.query.id != '') {
                this.openPayDetail(this.$route.query.id);
                this.$router.replace({'query': null});
            }
        },
    },
    computed: {
        ...mapState({
            items: state => state.paymentRequest.all.data,
            total_rows: state => state.paymentRequest.all.total,
            loading: state => state.paymentRequest.loading,
            currentPaymentRequest: state => state.paymentRequest.selected,
            customers: state => state.customer.master.data,
            addressBooks: state => state.addressBook.all.data,
        }),
        headers() {
            let tm_header = [
                {
                    text: "ID",
                    value: "ID",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "SĐT",
                    value: "ReceiverPhone",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Địa chỉ",
                    value: "ReceiverAddress",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Số kiện",
                    value: "TotalPackage",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phương thức giao",
                    value: "ShippingMethod",
                    filterable: true,
                    values: configs.SHIPPINGMETHODS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Ghi chú KH",
                    value: "CustomerNote",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    values: configs.PAYMENT_REQUEST_STATUS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Người tạo",
                    value: "CreatedBy",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Người sửa",
                    value: "ModifiedBy",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Thao tác",
                    width: 160
                }
                
            ];
            return tm_header;
        },
        totalPackageNumber() {
            return _.sumBy(this.currentPaymentRequest.Orders, "NumberOfPack");
        },
        totalVolume() {
            return _.sumBy(this.currentPaymentRequest.Orders, "Volume");
        },
        totalWeightByVolume() {
            return _.sumBy(this.currentPaymentRequest.Orders, "WeightByVolume");
        },
        totalPayWeight() {
            return _.sumBy(this.currentPaymentRequest.Orders, (item) => {
                return item.FeeShipType != 1 ? (item.FeeShipType == 0 ? item.Weight : item.WeightByVolume) : 0;
            });
        },
        totalWeight() {
            return _.sumBy(this.currentPaymentRequest.Orders, "Weight");
        },
        totalPayVolume() {
            return _.sumBy(this.currentPaymentRequest.Orders, (item) => {
                return item.FeeShipType == 1 ? item.Volume : 0;
            });
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
        },
        storeVNRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
        },
        csRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        },
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("paymentRequest/getList", param);
        },
        gotoDetail: function (id) {
            this.$router.push({
                name: "PaymentRequestDetail",
                params: {
                    Pid: id,
                    title: `Chi tiết yêu cầu giao hàng (#${id})`
                }
            });
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        createData(username = '') {
            // this.$store.commit("paymentRequest/setDetail", {data: {}});
            // this.dialogPayDetail = true;
            // this.selectedAddressID = 0;
            // this.newOrders = [];
            // this.selectedOrders = [];
            this.$router.push({
                name: "PaymentRequestDetail",
                params: {
                    Pid: 'tao-moi',
                title: `Tạo mới yêu cầu giao hàng`,
                },
            });
        },
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        openPayDetail(id) {
            // this.$store.dispatch("paymentRequest/getDetail", id);
            // this.dialogPayDetail = true;
            // this.selectedAddressID = 0;
            // this.newOrders = [];
            // this.selectedOrders = [];
            this.$router.push({
                name: "PaymentRequestDetail",
                params: {
                Pid: id,
                title: `Chi tiết yêu cầu giao hàng (#${id})`,
                },
            });
        },
        getCurrentShippingMethod() {
            const sm = _.find(this.shipping_methods, {value: this.currentPaymentRequest.ShippingMethod});
            return sm ? sm.name : '';
        },
        updateAddress() {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            let reqData = {...this.currentPaymentRequest};
            delete reqData.Status;
            this.$store.dispatch("paymentRequest/setDetail", {data: reqData, id: this.currentPaymentRequest.ID, ignore_reload: 1});
            this.dialogPayDetail = false;
        },
        saveItem(item, ignoreReload = 1) {
            this.$store.dispatch("paymentRequest/setDetail", {data: item, id: item.ID, ignore_reload: ignoreReload});
        },
        saveNewRequest() {
            if(this.selectedOrders.length == 0) {
                sendErrorNotice('Hãy chọn danh sách đơn hàng.')
                return;
            }
            if(!this.selectedAddressID) {
                sendErrorNotice('Hãy chọn địa chỉ giao hàng.')
                return;
            }
            this.currentPaymentRequest.TotalAmount = _.sumBy(this.selectedOrders, "TotalAmountVND");
            this.currentPaymentRequest.TotalPayment = _.sumBy(this.selectedOrders, "Deposit");
            this.currentPaymentRequest.TotalOrder = this.selectedOrders.length;
            this.currentPaymentRequest.Status = 1;
            this.$store.dispatch("paymentRequest/setDetail", {
                data: {
                    ...this.currentPaymentRequest,
                    IsPayLaster: this.isPayLaster,
                    Orders: this.selectedOrders
                },
                id: 0
            });
            this.dialogPayDetail = false;
        },
        getCustomerText(item) {
            return `DL${item.ID} - ${item.Username}`
        },
        onSelectedCustomer() {
            this.currentPaymentRequest.ReceiverName = '';
            this.currentPaymentRequest.ReceiverPhone = '';
            this.currentPaymentRequest.ReceiverAddress = '';
            this.selectedOrders = [];
            this.newOrders = [];
            if(this.currentPaymentRequest.UID > 0) {
                this.$store.dispatch("addressBook/getList", {
                filter: [{
                        column: "UID",
                        value: this.currentPaymentRequest.UID,
                        condition: "equal"
                    }]
                });
                const order_filter = [{
                        column: "UID",
                        value: this.currentPaymentRequest.UID,
                        condition: "equal"
                    },
                    {
                        column: 'Status',
                        value: [7,8],
                        condition: 'in'
                    },
                    {
                        column: 'TotalPackageUnRequest',
                        value: 0,
                        condition: 'greater_than'
                    }]
                this.$store.dispatch("main_order/getListOrders", { filter: order_filter }).then((r) => {
                    for (let i = 0; i < r.data.length; i++) {
                        const element = r.data[i];
                        this.newOrders.push({
                            PKey: `${element.ID}_1`,
                            ID: element.ID,
                            OrderType: 1,
                            PackageNumber: element.PackageNumber,
                            Weight: element.OrderWeight,
                            TotalAmountVND: element.TotalAmountVND,
                            Deposit: element.Deposit,
                            RemainAmount: element.TotalAmountVND - element.Deposit,
                        });
                    }
                });
                this.$store.dispatch("deposit/getList", { filter: order_filter }).then((r) => {
                    for (let i = 0; i < r.data.length; i++) {
                        const element = r.data[i];
                        this.newOrders.push({
                            PKey: `${element.ID}_2`,
                            ID: element.ID,
                            OrderType: 2,
                            PackageNumber: element.PackageNumber,
                            Weight: element.OrderWeight,
                            TotalAmountVND: element.TotalPriceVND,
                            Deposit: element.Payment,
                            RemainAmount: element.TotalPriceVND - element.Payment,
                        });
                    }
                });
            }
            else {
                this.$store.commit("addressBook/setList", {});
            }
        },
        getAddressText(item) {
            return `${item.Receiver} - ${item.Phone}`
        },
        onSelectedAddress() {
            const addr = _.find(this.addressBooks, {'ID': this.selectedAddressID});
            const customer = _.find(this.customers, {'ID': this.currentPaymentRequest.UID});
            if(addr) {
                this.currentPaymentRequest.UID = addr.UID;
                this.currentPaymentRequest.Username = customer.Username;
                this.currentPaymentRequest.ReceiverName = addr.Receiver;
                this.currentPaymentRequest.ReceiverPhone = addr.Phone;
                this.currentPaymentRequest.ReceiverAddress = addr.Address;
            }
        },
        printInList(id) {
            this.$store.dispatch("paymentRequest/getDetail", id).then((p) => {
                this.printPayOrder();
            });
        },
        printPayOrder() {
            const result = _.uniqWith(_.map(this.currentPaymentRequest.Orders, (p) => {
                return {OrderID: p.OrderID, OrderType: p.OrderType, TotalAmountVND: p.TotalAmountVND, Deposit: p.Deposit}
            }), _.isEqual);
            const totalAmountVND = _.sumBy(result, function(o) { return o.TotalAmountVND; });
            const totalDeposit = _.sumBy(result, function(o) { return o.Deposit; });
            const totalPayLeft = totalAmountVND - totalDeposit;
            const customer = _.find(this.customers, {'ID': this.currentPaymentRequest.UID});
            const frame_printing = print_export_receipt_order_v1({'ID': this.currentPaymentRequest.ID, 'CustomerID': this.currentPaymentRequest.UID, 'CustomerName': this.currentPaymentRequest.ReceiverName, 'PhoneNumber': this.currentPaymentRequest.ReceiverPhone, 'Address': this.currentPaymentRequest.ReceiverAddress, 'PayLeft': totalPayLeft, 'Wallet': customer.Wallet, 'Remain': (customer.Wallet > totalPayLeft ? 0 : totalPayLeft - customer.Wallet), 'Orders': this.currentPaymentRequest.Orders}, this.currentPaymentRequest.Orders, true, true);
            var doc = document.getElementById('print_frame').contentWindow.document;
            doc.open();
            doc.write(frame_printing);
            doc.close();
            setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
        }
    },
    mounted() {
        this.$store.dispatch("customer/getCustomerList", {
            is_master: 1,
            fields: ["ID", "Username", "ReceivePlaceID", "ChinaStoreID", "Wallet"]
        });
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("paymentRequest/removeDetail", id);
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
<style>
.fee-cn-footer .v-text-field .v-label--active {
  right: 0px !important;
  left: auto !important;
}

.fee-cn-footer .v-text-field__slot input {
  text-align: right !important;
  font-size: 0.9em !important;
}
</style>